import { Component, OnInit, Input, EventEmitter, Output, ɵbypassSanitizationTrustStyle } from '@angular/core';
import { ConfigService } from 'src/app/services/api/config/config.service';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { AppService } from 'src/app/app.service';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { CharacteristicsConverter } from 'src/app/services/api/characteristics/characteristics.converter';
import { MatDialog, MatDialogRef } from '@angular/material';
import { JsonComponent } from 'src/app/core/json/json.component';
import { OrderService } from 'src/app/services/api/orders/specific-order/order.service';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-order-details-general-info-default',
  templateUrl: './order-details-general-info-default.component.html',
  styleUrls: ['./order-details-general-info-default.component.css']
})
export class OrderDetailsGeneralInfoDefaultComponent implements OnInit {

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }
  @Input() params: any;
  @Input() isps: any[];
  appData: any;
  orderStatus: OrderStatusObject;
  characteristics: CharacteristicsObject;

  loading: boolean;

  json: any;
  jsonRef: MatDialogRef<JsonComponent>;

  @Output() decompositeOrderEvent = new EventEmitter();

  constructor(private configService: ConfigService,
    private appService: AppService, private characteristicsConverter: CharacteristicsConverter,
    private ordersService: OrdersService, public dialog: MatDialog,
    private orderService: OrderService) {

  }

  ngOnInit() {
    this.loading = false;
    this.appData = this.appService.settings;
    this.orderStatus = OrderStatusObject.createWithStatus(this.summary.state);
    this.getJson();
  }

  toOption(type: OrderTypeObject): string {
    switch (type) {
      case OrderTypeObject.PRODUCT:
        return 'productOrders';
      case OrderTypeObject.CFS, OrderTypeObject.RFS:
        return 'serviceOrders';
      default:
        return null;
    }
  }

  goToOrderType() {
    switch (this.params.type) {
      case 'product':
        this.jsonRef = this.dialog.open(JsonComponent, {
          data: { title: 'Información de la orden de producto', json: this.json },
          width: '850px'
        });
        break;
      case 'cfs':
        this.jsonRef = this.dialog.open(JsonComponent, {
          data: { title: 'Información de la orden de servicio', json: this.json },
          width: '850px'
        });
        break;
      case 'rfs':
        this.jsonRef = this.dialog.open(JsonComponent, {
          data: { title: 'Información de la orden de recurso', json: this.json },
          width: '850px'
        });
        break;
    }
  }

  decomposeOrder() {
    this.loading = true;
    this.orderService.decomposeProductOrder(this.summary.id, this.json).pipe(
      delay(15000)
    ).subscribe(
      (data) => {
        this.loading = false;
        this.getJson();
        this.decompositeOrderEvent.emit();
      }
    );
  }

  getJson() {
    if (this.params) {
      switch (this.params.type) {
        case 'product':
          this.ordersService.getProductOrder(this.summary.id).subscribe(
            data => {
              this.json = data;
              delete this.json._links;
            }
          );
          break;
        case 'cfs':
        case 'rfs':
          this.ordersService.getServiceOrder(this.summary.id).subscribe(
            data => {
              this.json = data;
              delete this.json._links;
            }
          );
          break;
      }
    }
  }

}
